<template>
  <div class="to_grant_authorization">
    <div class="top">
      <i class="el-icon-back" @click="$router.go(-1)"></i>
      <p>{{$t('bank_card.Ass_Acc_View')}}</p>
    </div>
    <main style="pointer-events: none">
      <el-tree
        :data="data_list"
        show-checkbox
        default-expand-all
        node-key="id"
        ref="tree"
        highlight-current
        :props="defaultProps"
      >
      </el-tree>
    </main>
  </div>
</template>

<script>
// import { auth_auth } from "@/api/api";
export default {
  data() {
    return {
      data_list: [
    {
      id: "1",
      label: "Dashboard",
      children: [
        {
          id: "1-1",
          label: "Account Summary",
        },
        {
            id: "1-2",
            label: "Bank Statement",
          },
          {
            id: "1-3",
            label: "Card",
          },
          {
            id: "1-4",
            label: "Balance",
          }
      ],
    },{
        id: "2",
        label: "My Account",
        children: [
          {
            id: "2-1",
            label: "USDT Balance",
          },
          {
              id: "2-2",
              label: "USDC Balance",
            },
            {
              id: "2-3",
              label: "Transaction History",
            },
            {
              id: "2-4",
              label: "particulars",
            },
            {
              id: "2-5",
              label: "PDF",
            },
            {
              id: "2-6",
              label: "CSV",
            }
        ],
      },{
        id: "3",
        label: "Deposit",
        children: [
          {
            id: "3-1",
            label: "Fiat Deposit",
          },
          {
              id: "3-2",
              label: "Make a Fiat Deposit",
            },
            {
              id: "3-3",
              label: "Transaction History",
            },
            {
              id: "3-4",
              label: "Export",
            },
            {
              id: "3-5",
              label: "Digital Asset Deposit",
            },
            {
              id: "3-6",
              label: "Transaction History",
            },
            {
              id: "3-7",
              label: "Export",
            }
        ],
      },{
        id: "11",
        label: "Transfer & Payments",
        children: [
          {
            id: "11-1",
            label: "Fiat Transfer & Payments",
          },
          {
            id: "11-2",
            label: "Manage My Payee",
          },
          {
              id: "11-3",
              label: "Transfer/Payment to Payee",
            },
            {
              id: "11-4",
              label: "Transaction History",
            },
            {
              id: "11-5",
              label: "Export",
            },
            {
              id: "11-6",
              label: "Digital Asset Transfer & Payments",
            },
            {
              id: "11-7",
              label: "Manage My Addresses",
            },
            {
              id: "11-8",
              label: "Transfer/Payment to Other Address",
            },
            {
              id: "11-9",
              label: "Transaction History",
            },
            {
              id: "11-10",
              label: "Export",
            }
        ],
      },{
        id: "4",
        label: "Cards",
        children: [
          {
            id: "4-1",
            label: "Apply Card",
          },
          {
              id: "4-2",
              label: "View List",
            },
            {
              id: "4-3",
              label: "Top-up",
            },
            {
              id: "4-4",
              label: "Reset PIN",
            },
            {
              id: "4-5",
              label: "Transaction History",
            },
            {
              id: "4-6",
              label: "particulars",
            },
            {
              id: "4-7",
              label: "Refresh",
            },
            {
              id: "4-8",
              label: "Top-up History",
            }
        ],
      },{
        id: "5",
        label: "OTC", 
      },{
        id: "6",
        label: "Private Banking Products", 
      },{
        id: "7",
        label: "Structured Products", 
      },{
        id: "8",
        label: "Investment Banking", 
      },{
        id: "9",
        label: "Pre-order Module",
        children: [
          {
            id: "9-1",
            label: "Cards Pre-Order Management - Contracts",
          },
          {
              id: "9-2",
              label: "Order",
            },
            {
              id: "9-3",
              label: "View Contract",
            },
            {
              id: "9-4",
              label: "View Order Details",
            },
            {
              id: "9-5",
              label: "Card Management",
            },
            {
              id: "9-6",
              label: "View List",
            },
            {
              id: "9-7",
              label: "operation",
            }
        ],
      },{
        id: "10",
        label: "Secondary account management - View Access rights",
      },{
        id: "12",
        label: "KYC Management",
        children: [
          {
            id: "12-1",
            label: "Edit submit",
          }
        ]
      }
      

      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
      
    };
  },
  mounted() {
    const info_authjson = JSON.parse(sessionStorage.getItem("info_authjson"));
    if(info_authjson){
      this.setKey(info_authjson);
      // this.$refs.tree.setCheckedKeys(["1","1-1","1-2"]);
    }
  },
  methods: {
    setKey(v){
      const arr = [...v];
      this.$refs.tree.setCheckedKeys(arr);
    }
  },
};
</script>

<style lang="less" scoped>
.to_grant_authorization {
  width: 100%;
  color: white;
  .top {
    display: flex;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
      margin-right: 20px;
    }
  }
  .operation {
    margin: 15px 0;
  }
}
</style>
<style>
.to_grant_authorization .el-tree {
  background: no-repeat;
  color: white;
}
.to_grant_authorization .el-tree-node:focus > .el-tree-node__content {
  background-color: #071f34 !important;
}
.to_grant_authorization .el-tree-node__content:hover {
  background-color: #071f34;
}
.to_grant_authorization
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #071f34;
}
.to_grant_authorization .el-tree-node.is-expanded > .el-tree-node__children {
  display: flex;
  flex-wrap: wrap;
}
.to_grant_authorization .el-tree-node__content {
  height: 35px;
}
</style>